export default "__VITE_ASSET__DX9wuSrU__"